export enum DocumentStatusKey {
    PLANNED = 'PLANNED',
    PENDING_CONTENT = 'PENDING_CONTENT', 
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    REJECTED = 'REJECTED',
    PREPUBLISHED = 'PREPUBLISHED',
    PUBLISHED = 'PUBLISHED',
    ACCEPTED = 'ACCEPTED',
    ERROR = 'ERROR'
}